const hostApi = process.env.NODE_ENV === "development" ? "https://be.simko-aps.mysurvey.id": "dev-bpm" ? "https://be.simko-aps.mysurvey.id" : "https://be.simko-aps.mysurvey.id";
const portApi = process.env.NODE_ENV === "development" ? 3030 : "3010";
// const baseURLApi = `${hostApi}${portApi ? `` : ``}`;
const baseURLApi = `${hostApi}`;

//import loginData from "../pages/Login/Login"
 
export default {
  hostApi,
  portApi,
  baseURLApi,
}